// extracted by mini-css-extract-plugin
export default {"container":"register_container__bTtzQ","form":"register_form__RqTiS","actions":"register_actions__DVoAJ","actions__link":"register_actions__link__hukqV"};